export function extractFilenameFromUrl(url: string): string | undefined {
  const pathname = new URL(url).pathname
  return pathname.split("/").pop()
}

export function extractGifUrlFromUrl(src: string): string | null {
  const regex = /\.gif\?[^"]*u=([^&]+)/g
  const match = regex.exec(src)
  if (match) {
    return decodeURIComponent(match[1])
  }
  return null
}

export function getTimeIntervalsForArchive() {
  const startYear = 2006
  const currentYear = new Date().getFullYear()
  const intervals: string[] = []

  for (let year = startYear; year <= currentYear; year += 5) {
    intervals.push(`${year + 4 > currentYear ? currentYear : year + 4}-${year}`)
  }

  return intervals.reverse()
}
